import { z } from "zod";

import { SingleEmployeeSchema } from "../../components/EmployeePicker/utils";

import { config } from "./config";

export const CompanyMeetingsFiltersSchema = z.object({
	participant: SingleEmployeeSchema.optional(),
	dateRangeStart: z.date().optional(),
	dateRangeEnd: z.date().optional(),
	status: z.array(z.enum(config.statusOptions)).optional(),
});
export type CompanyMeetingsFilters = z.infer<typeof CompanyMeetingsFiltersSchema>;
